import { StepperItemProps } from '@/components/stepper/stepper.types.ts';
import { memo } from 'react';
import clsx from 'clsx';

const StepperItem = memo(({ step, isActive, isCompleted, onClick, currentStep, completedSteps, progress }: StepperItemProps) => {
	const { id, icon, title, description } = step;

	const handleClick = () => {
		if (id === 1 || isCompleted || isActive || (id === currentStep + 1 && completedSteps.includes(id - 1))) {
			onClick(id);
		}
	};

	const stepClassName = clsx('stepper__item', {
		active: isActive,
		completed: isCompleted,
		'in-progress': progress > 0 && progress < 100,
		clickable: id === 1 || isCompleted || isActive
	});

	const style =
		progress > 0 && !isCompleted
			? ({
					'--progress-height': `${progress}%`
				} as React.CSSProperties)
			: {};

	return (
		<div
			className={stepClassName}
			onClick={handleClick}
			style={style}>
			{!isCompleted && progress > 0 && <div className="progress-line" />}
			<div className="stepper__item__icon">
				<i
					className={clsx(icon, {
						completed: isCompleted || isActive
					})}
				/>
			</div>
			<div className="stepper__item__header">
				<span className="stepper__item__number">{id}.</span>
				<h3>{title}</h3>
			</div>
			<p>{description}</p>
		</div>
	);
});

export default StepperItem;
